import { Box, Flex, styled } from "@acko-tech/building-blocks.ui.common";
import { Text } from "@acko-tech/building-blocks.ui.typography";

export const ItemsContainer = styled(Flex)`
  margin-top: 1.5rem;
  flex-direction: column;
  gap: 20px;
`;

export const Item = styled(Flex)`
  flex-direction: row;
  gap: 1rem;
  align-items: flex-start;
`;

export const ItemName = styled(Text)`
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: #040222;
`;

export const ItemDescription = styled(Text)`
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  color: #5b5675;

  ul {
    margin-top: 0px;
    padding: 0px;
    margin-left: 10px;
  }

  li {
    margin-top: 0.5rem;
  }
`;

export const OptionsWrapper = styled.div`
  overflow: scroll;

  ::-webkit-scrollbar {
    display: none;
  }
`;

export const OptionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: max-content;
  height: 100%;

  margin-top: 2rem;
  margin-bottom: 2rem;

  & > :first-child {
    margin-left: 0px;
  }
`;

export const Option = styled.div`
  margin-left: 12px;
  padding: 8px 16px;
  border-radius: 24px;
  border: 1px solid #e7e7f0;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  width: max-content;
  display: inline;

  color: #040222;
  background: #ffffff;

  ${(props) =>
    props.isSelected &&
    `
    color: #FFFFFF;
    background: #040222;
    border: 1px solid #040222;
    font-weight: 500;
    `};

  ${(props) =>
    props.isUpgradeOption &&
    `
    border: 2px solid transparent;
    background:
    linear-gradient(white, white) padding-box,
    linear-gradient(91deg, #ffe6c1 0.32%, #d59ffc 50.03%, #b4e5ff 99.73%)
      border-box;
    border-radius: 24px;
    `};

  ${(props) =>
    props.isUpgradeOption &&
    props.isSelected &&
    `
    border: 1px solid #040222;
    background: #040222;
    color: transparent;
    font-weight: 600;
    `};

  cursor: pointer;
`;

export const OptionName = styled.div`
  width: max-content;

  ${(props) =>
    props.isUpgradeOption &&
    props.isSelected &&
    `
    background: linear-gradient(91deg, #FFE6C1 0.32%, #D59FFC 50.03%, #B4E5FF 99.73%);;
  background-clip: text;
  color: transparent;
    `}
`;

export const ZdTable = styled(Flex)`
  flex-direction: column;
  border-radius: 12px;
  border: 1px solid #e7e7f0;
  overflow: hidden;
`;

export const Row = styled(Flex)`
  width: 100%;
`;

export const ZdItem = styled(Flex)`
  background: ${(props) => props.background || "white"};
  align-items: center;
  justify-content: center;
  color: #36354c;
  font-size: 12px;
  padding: 1rem 0.5rem;

  ${(props) =>
    props.isFeature &&
    `
    justify-content: flex-start;
    min-width: 50%;
    padding-left: 12px;
    `}

  ${(props) =>
    props.isTitle &&
    `
    color: #040222;
    font-weight: 600;
    text-align: center;
    `}
`;

export const ModalPrimaryContent = styled(Text)`
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  color: #040222;
`;

export const ModalSecondaryContent = styled(Text)`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #36354c;
`;

export const ZdExampleCard = styled.div`
  border-radius: 12px;
  border: 1px solid var(--line-primary-n-200, #e7e7f0);
  background: var(--Surface-White, #fff);
  overflow: hidden;
  margin-top: 1rem;
`;
